// extracted by mini-css-extract-plugin
module.exports = {"blob":"blobMaskMorpher__blob__bFoia"};